import { DRAW_PALETTE } from '@redpandev/shared';

/**
 * Cover décorative de la carte « Griffonne » : un petit gribouillis + la palette
 * de couleurs bornée (les vraies couleurs du jeu). Purement ornemental
 * (`aria-hidden` posé par GameCard) — aucune donnée réelle.
 */
export function GriffonneCover() {
  return (
    <div className="flex h-28 items-center justify-center gap-4 rounded-lg border border-ink-600/40 bg-app/60">
      <svg viewBox="0 0 64 48" className="h-16 w-20" aria-hidden="true">
        {/* gribouillis façon dessin rapide */}
        <path
          d="M8 34 C 14 10, 24 10, 26 26 S 40 42, 44 22 46 10 56 14"
          fill="none"
          stroke="var(--rp-panda-500, #f97316)"
          strokeWidth="3"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <circle cx="50" cy="34" r="4" fill="var(--rp-grape-500, #8b5cf6)" />
      </svg>
      <div className="grid grid-cols-3 gap-1.5">
        {DRAW_PALETTE.slice(0, 6).map((hex) => (
          <span
            key={hex}
            className="h-4 w-4 rounded-full border border-ink-600/50"
            style={{ backgroundColor: hex }}
          />
        ))}
      </div>
    </div>
  );
}
